import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames/bind'

import HighlightSearchTerm from './highlightSearchTerm'
import SearchIcon from '../../../shared/components/icons/search'
import CloseIcon from '../../../shared/components/icons/close'
import ExpandIcon from '../../../shared/components/icons/expand'

import styles from './autosuggest.module.css'

class AutoSuggest extends React.Component {
  static propTypes = {
    suggestions: PropTypes.array.isRequired,
    onInputChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    onSelectOption: PropTypes.func.isRequired,
    inputName: PropTypes.string,
    inputValue: PropTypes.string
  }

  static defaultValue = {
    inputValue: ''
  }

  renderWrapper() {
    const {
      suggestions,
      focusedIndex,
      inputValue,
      textInputRef,
      wrapperRef,
      setMenuRef,
      onMenuClick,
      handleMenuMouseEnter,
      handleMenuMouseLeave
    } = this.props

    /**
     * Hack inline style :magic:
     */
    const wrapperStyle = {
      position: 'absolute',
      top: textInputRef.clientHeight,
      width: wrapperRef.clientWidth
    }

    return (
      <div
        className={styles.autosuggestWrapper}
        data-test-selector="autosuggestWrapper"
        style={wrapperStyle}
      >
        <section ref={setMenuRef} className={styles.autosuggestList}>
          <ul data-test-selector="autosuggestList">
            {suggestions.map((suggestion, index) => {
              const autosuggestListItemClassNames = classNames({
                [styles.autosuggestListItemFocused]: focusedIndex === index
              })
              return (
                <li
                  data-test-selector="autosuggestListItem"
                  className={autosuggestListItemClassNames}
                  onMouseDown={event => onMenuClick(suggestion, event)}
                  onMouseEnter={event => handleMenuMouseEnter(index)}
                  onMouseLeave={event => handleMenuMouseLeave(index)}
                  key={index}
                >
                  <a className={styles.autosuggestLink} href={suggestion.link}>
                    <HighlightSearchTerm
                      term={inputValue.trim()}
                      suggestionText={suggestion.text}
                    />
                    <ExpandIcon
                      className={styles.expandIcon}
                      width="18"
                      height="18"
                    />
                  </a>
                </li>
              )
            })}
          </ul>
        </section>
      </div>
    )
  }

  render() {
    const {
      isOpen,
      inputValue,
      suggestions,
      inputName,
      placeholder,
      type,
      ariaLabel,
      setWrapperRef,
      setTextInputRef,
      handleInputChange,
      handleInputFocus,
      handleKeyDown,
      handleKeyUp,
      onSearchDismiss,
      handleButtonFocus
    } = this.props

    const inputStyle = {
      borderRadius: isOpen && suggestions.length ? '2px 0 0 0' : '2px 0 0 2px'
    }

    const buttonStyle = {
      borderRadius: isOpen && suggestions.length ? '0 2px 0 0' : '0 2px 2px 0'
    }

    return (
      <div ref={setWrapperRef} className={styles.searchWrapper}>
        <input
          ref={setTextInputRef}
          className={styles.searchInput}
          style={inputStyle}
          placeholder={placeholder || ''}
          autoComplete="off"
          autoCapitalize="off"
          autoCorrect="off"
          type={type || 'search'}
          aria-label={ariaLabel || 'search'}
          name={inputName || ''}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
        />
        {isOpen &&
          suggestions &&
          suggestions.length > 0 &&
          this.renderWrapper()}
        {inputValue !== '' && (
          <button
            onClick={onSearchDismiss}
            className={styles.closeButton}
            onFocus={handleButtonFocus}
          >
            <CloseIcon width="10" height="10" />
          </button>
        )}
        <button
          className={styles.searchBtn}
          style={buttonStyle}
          defaultValue="Submit"
          onFocus={handleButtonFocus}
        >
          <span className={styles.searchBtnLabel}>Search</span>
          <SearchIcon className={styles.searchBtnIcon} width="20" height="20" />
        </button>
      </div>
    )
  }
}

export default AutoSuggest
